<template lang="pug">
  .category_container.page_container
    .page_header
      .page_header_column
        b-field
          b-input(
            v-model="searchForm.key"
            placeholder="キーワードで検索"
            type="search"
            icon="search"
            rounded
            size="is-medium")
      .page_header_column
        b-button(
          type="is-info"
          size="is-medium"
          outlined
          icon-left="plus"
          @click="openCategoryModal('add')") カテゴリの追加
    .categoryList(v-if="categoryList" v-cloak)
      b-table(
        :data="categoryList"
        ref="table"
        :bordered="table.isBordered"
        :striped="table.isStriped"
        :narrowed="table.isNarrowed"
        :loading="table.isLoading"
        :mobile-cards="table.hasMobileCards"
        :default-sort-direction="table.defaultSortDirection"
        :sort-icon="table.sortIcon"
        :sort-icon-size="table.sortIconSize"
        :row-class="(row, index) => ( categoryList.length !== parentCategoryList.length ) && !row.parent_name && '_row_category'"
        hoverable
        class="categoryList_table")
        b-table-column(v-slot="props" field="screen_name" label="カテゴリ名（表示用）" width="190" sortable)
          span._name._sub_category(v-if="props.row.parent_name") {{ props.row.screen_name }}
          span._name._category(v-else) {{ props.row.screen_name }}
        b-table-column(v-slot="props" field="value" label="カテゴリ名（URL用）" width="180" sortable)
          span._value(v-if="props.row.value") {{ props.row.value }}
        b-table-column(v-slot="props" field="parent_name" label="親カテゴリ" width="160" sortable)
          span._parent(v-if="props.row.parent_name") {{ props.row.parent_name }}
        b-table-column(v-slot="props" field="color" label="ラベルカラー" width="100" centered)
          span._color(v-if="props.row.color" :style="{ color: props.row.color.text, 'background-color': props.row.color.background }")
        b-table-column(v-slot="props" field="edit" label="編集" width="60" centered)
          button.ui-icon-button(v-if="props.row.screen_name !== '未分類' && props.row.parent_name" @click="openCategoryModal( 'edit', props.row )")
            b-icon.is-opacity(icon="edit")
        b-table-column(v-slot="props" field="delete" label="削除" width="60" centered)
          button.ui-icon-button(v-if="props.row.screen_name !== '未分類' && props.row.parent_name" @click="deleteConfirm(props.row)")
            b-icon.is-danger(icon="trash-alt")
        template(v-slot:empty v-if="!isInitialLoading")
          p._empty_message 該当するカテゴリはありません
    // 追加・編集モーダル
    b-modal.categoryModal(v-model="isModalActive" :width="640")
      category-modal(
        :is-modal-active="isModalActive"
        :modal-type="modalType"
        :parent-category-list="parentCategoryList"
        :category-data="selectedCategoryData"
        @setNewData="getCategoryList"
        @closeModal="closeCategoryModal()")
</template>

<script>
import CategoryModal from '@/components/CategoryModal.vue'

export default {
  name: 'Category',
  head: {
    title() {
      return {
        inner: 'カテゴリ',
        separator: '|',
        complement: '管理画面',
      }
    }
  },
  components: {
    CategoryModal
  },
  data: function(){
    return {
      parentCategoryList: [],
      categoryList: [],
      isInitialLoading: true,

      /* 追加フォーム */
      selectedCategoryData: null,
      isModalActive: false,
      modalType: null,

      /* 絞り込みフォーム */
      searchForm: {
        key: null,
      },

      /* b-table settings */
      table: {
        isEmpty: false,
        isBordered: false,
        isStriped: false,
        isNarrowed: false,
        isLoading: false,
        hasMobileCards: true,
        defaultSortDirection: 'asc',
        sortIcon: 'arrow-up',
        sortIconSize: 'is-small',
        isPaginated: false,
      }
    }
  },
  created() {
    this.getCategoryList()
  },
  watch: {
    'searchForm.key'(val){
      val.length > 0 ? this.searchCategory() : this.getCategoryList()
    }
  },
  methods: {
    openCategoryModal(type, data){
      if( type === 'edit' ) {
        this.selectedCategoryData = data
      }

      this.modalType = type
      this.isModalActive = true
    },
    closeCategoryModal(){
      this.isModalActive = false
    },
    deleteConfirm(category){
      let message
      if( category.last_flag ) {
        message = 'このカテゴリを削除すると、同じ親カテゴリ内の「未分類」カテゴリも削除されます。'
      } else {
        message = 'このカテゴリを選択している記事がある場合は、カテゴリを選択し直してから削除してください。'
      }
      this.$buefy.dialog.confirm({
        title: category.screen_name + ' を削除しますか？',
        message: message,
        confirmText: 'カテゴリを削除する',
        cancelText: 'キャンセル',
        type: 'is-danger',
        size: 'is-medium',
        hasIcon: true,
        icon: 'exclamation-circle',
        onConfirm: () => {
          this.deleteCategory(category)
        }
      })
    },
    async getCategoryList() {
      try {
        this.table.isLoading = true

        const data_obj = {
          sort: 2
        }

        const res = await this.$axios.get(
            process.env.VUE_APP_API_ENDPOINT
            + process.env.VUE_APP_API_BASE_PATH
            + this.$constants.API_PATH.CATEGORIES,
            { params: data_obj }
        )

        const r = res.data

        if( r.status == 1 ){
          const data = r.data
          this.parentCategoryList = data

          let _categoryList = new Array()
          for(let i = 0; i < data.length; i++) {
            _categoryList.push(data[i])
            for(let ci = 0; ci < data[i].sub_category.length; ci++) {
              let _sub_category = data[i].sub_category[ci]
              _sub_category.parent_name = data[i].screen_name
              _sub_category.last_flag = data[i].sub_category.length === 2 ? true : false

              const latestCategory = _categoryList[_categoryList.length - 1]

              if(latestCategory.screen_name === '未分類') {
                _categoryList.splice(-1, 0, _sub_category)
              } else {
                _categoryList.push(_sub_category)
              }
            }
          }
          this.categoryList = _categoryList

        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, 'カテゴリの取得に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.table.isLoading = false
        this.isInitialLoading = false
      }
    },
    async searchCategory() {
      try {
        this.table.isLoading = true

        const data_obj = {
          sort: 2,
          keyword: this.searchForm.key
        }

        const res = await this.$axios.get(
            process.env.VUE_APP_API_ENDPOINT
            + process.env.VUE_APP_API_BASE_PATH
            + this.$constants.API_PATH.CATEGORIES,
            { params: data_obj }
        )

        const r = res.data

        if( r.status == 1 ){
          const data = r.data

          let _categoryList = new Array()
          let _category = {
            name: null,
            parent_name: null,
            id: null,
          }
          for( let i = 0; i < data.length; i++ ) {
            if( data[i].sub_category ){
              const parentCategory = this.parentCategoryList.find( parentCategory => parentCategory.id === data[i].id )
              const _lastFlag = parentCategory.sub_category.length === 2 ? true : false

              _category = {
                parent_name: data[i].screen_name,
                screen_name: data[i].sub_category.screen_name,
                value: data[i].sub_category.value,
                color: data[i].sub_category.color,
                id: data[i].sub_category.id,
                last_flag: _lastFlag
              }
            } else {
              _category = {
                parent_name: null,
                screen_name: data[i].screen_name,
                value: data[i].value,
                id: data[i].id
              }
            }
            _categoryList.push(_category)
          }

          this.categoryList = _categoryList
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, 'カテゴリの取得に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.table.isLoading = false
      }
    },
    async deleteCategory(category) {
      try {
        let res
        if( category.parent_name == null ) { // 親カテゴリ削除
          res = await this.$axios.delete(
            process.env.VUE_APP_API_ENDPOINT
            + process.env.VUE_APP_API_BASE_PATH
            + this.$constants.API_PATH.CATEGORIES_.replace(':id', category.id)
          )
        } else { // 子カテゴリ削除
          res = await this.$axios.delete(
            process.env.VUE_APP_API_ENDPOINT
            + process.env.VUE_APP_API_BASE_PATH
            + this.$constants.API_PATH.SUB_CATEGORIES_.replace(':id', category.id)
          )
        }

        const r = res.data

        if( r.status == 1 ){
          this.$common.createSuccessMessage('カテゴリ '+ category.screen_name + ' を削除しました')
          this.getCategoryList()
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, 'カテゴリの削除に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
  }
}
</script>